var map = {
	"./defaultLogo.png": 1223,
	"./resources/logos/header/headerLogo.png": 1217,
	"./resources/main": 456,
	"./resources/main.json": 456,
	"./resources/robots/Flexa/Flexa.png": 1218,
	"./resources/robots/L50/L50.png": 1219,
	"./resources/robots/Leovac/leovac.png": 1220,
	"./resources/robots/S75/S75.png": 1221,
	"./resources/robots/V40/V40.png": 1222
};
var fakeMap = {
	"456": 3,
	"1217": 9,
	"1218": 9,
	"1219": 9,
	"1220": 9,
	"1221": 9,
	"1222": 9,
	"1223": 9
};

function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, fakeMap[id])
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1927;
module.exports = webpackAsyncContext;